// PR-1769 / PR-1785 : quantité maximale par article, lue dans la balise produit LIMITn (n ≥ 1, casse ignorée ;
// plusieurs balises : la plus petite).
// Sans balise : réglage quantite_max_par_article (0 = aucune limite).
// Balises connues : injectées par theme.liquid (produit de la page, lignes du panier), sinon lues dans /products/<handle>.js.
// 1. Sélecteurs de quantité (fiche, panier, tiroir) : attribut max, « + » bloqué, message « Limite : N par client ».
// 2. /cart/add, /cart/change, /cart/update passés par le thème : quantité ramenée à ce qui reste permis.
// 3. Contrôle du panier au chargement et après chaque appel : toute ligne au-delà est ramenée au maximum par /cart/change.js.
(function () {
  const R = window.quantiteMax || {};
  const MAX_GLOBAL = parseInt(R.parArticle, 10) > 0 ? parseInt(R.parArticle, 10) : Infinity;
  const VARIANTES = R.variantes || {};
  const message = (n) => `Limite : ${n} par client`;
  const fetchOrigine = window.fetch.bind(window);
  const lirePanier = () => fetchOrigine('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  const parVariante = (panier) =>
    panier.items.reduce((acc, l) => ((acc[l.variant_id] = (acc[l.variant_id] || 0) + l.quantity), acc), {});
  const handleDeLien = (a) => ((a && a.getAttribute('href')) || '').match(/\/products\/([^/?#]+)/)?.[1] || '';

  // Limite d'un produit d'après ses balises.
  const depuisBalises = (balises) => {
    const n = (balises || [])
      .map((b) => parseInt((String(b).trim().match(/^LIMIT(\d+)$/i) || [])[1], 10))
      .filter((x) => x >= 1);
    return n.length ? Math.min(...n) : MAX_GLOBAL;
  };
  const limites = {};
  Object.entries(R.balises || {}).forEach(([h, b]) => (limites[h] = depuisBalises(b)));
  const enCours = {};
  const limiteHandle = (h) => {
    if (!h) return Promise.resolve(MAX_GLOBAL);
    if (h in limites) return Promise.resolve(limites[h]);
    return (enCours[h] ||= fetchOrigine(`/products/${h}.js`)
      .then((r) => (r.ok ? r.json() : null))
      .then((p) => (limites[h] = p ? depuisBalises(p.tags) : MAX_GLOBAL))
      .catch(() => (limites[h] = MAX_GLOBAL)));
  };
  // Lecture synchrone pour l'affichage : inconnue ⇒ chargée, puis l'affichage est refait.
  const limiteConnue = (h) => {
    if (h in limites) return limites[h];
    if (h) limiteHandle(h).then(surveiller);
    return Infinity;
  };
  const limiteVariante = async (id, panier) => {
    const ligne = panier.items.find((l) => String(l.variant_id) === String(id));
    if (ligne) return limiteHandle(ligne.handle);
    return VARIANTES[id] ? limiteHandle(VARIANTES[id]) : MAX_GLOBAL;
  };

  const route = (entree) => {
    try {
      const p = new URL(typeof entree === 'string' ? entree : entree.url, location.origin).pathname;
      const m = p.match(/\/cart\/(add|change|update)(\.js)?$/);
      return m ? m[1] : null;
    } catch (e) {
      return null;
    }
  };
  const refus = (n) =>
    new Response(JSON.stringify({ status: 422, message: message(n), description: message(n) }), {
      status: 422,
      headers: { 'Content-Type': 'application/json' },
    });

  // Corps FormData ou JSON : lecture et écriture des champs id, line, quantity, items, updates.
  const lireCorps = (corps) => {
    if (corps instanceof FormData) return { type: 'form', d: corps };
    if (typeof corps === 'string') {
      try {
        return { type: 'json', d: JSON.parse(corps) };
      } catch (e) {
        return null;
      }
    }
    return null;
  };
  const champ = (c, k) => (c.type === 'form' ? c.d.get(k) : c.d[k]);
  const poser = (c, k, v) => (c.type === 'form' ? c.d.set(k, String(v)) : (c.d[k] = v));
  const ecrireCorps = (c) => (c.type === 'form' ? c.d : JSON.stringify(c.d));

  // Rend le corps borné, ou { refus: n } si plus rien n'est permis.
  const borner = async (nom, c) => {
    const panier = await lirePanier();
    const qte = parVariante(panier);
    if (nom === 'add') {
      const enListe = c.type === 'json' && Array.isArray(c.d.items);
      const items = enListe ? c.d.items : [{ id: champ(c, 'id'), quantity: champ(c, 'quantity') }];
      const gardes = [];
      let n = MAX_GLOBAL;
      for (const it of items) {
        const max = await limiteVariante(it.id, panier);
        const reste = max - (qte[it.id] || 0);
        const q = parseInt(it.quantity || 1, 10);
        if (reste > 0) gardes.push({ ...it, quantity: Math.min(q, reste) });
        else n = max;
      }
      if (!gardes.length) return { refus: n };
      if (enListe) c.d.items = gardes;
      else poser(c, 'quantity', gardes[0].quantity);
      return c;
    }
    if (nom === 'change') {
      const ligneNo = parseInt(champ(c, 'line'), 10);
      const id = champ(c, 'id');
      const ligne = ligneNo
        ? panier.items[ligneNo - 1]
        : panier.items.find((l) => l.key === String(id) || String(l.variant_id) === String(id));
      const q = parseInt(champ(c, 'quantity'), 10);
      if (ligne && q > 0) {
        const max = await limiteHandle(ligne.handle);
        poser(c, 'quantity', Math.min(q, Math.max(0, max - (qte[ligne.variant_id] - ligne.quantity))));
      }
      return c;
    }
    if (nom === 'update' && c.type === 'json' && c.d.updates && typeof c.d.updates === 'object' && !Array.isArray(c.d.updates)) {
      for (const k of Object.keys(c.d.updates)) {
        const ligne = panier.items.find((l) => l.key === k || String(l.variant_id) === k);
        const max = ligne ? await limiteHandle(ligne.handle) : await limiteVariante(k, panier);
        c.d.updates[k] = Math.min(parseInt(c.d.updates[k], 10) || 0, max);
      }
    }
    return c;
  };

  let minuterie;
  const planifierControle = () => {
    clearTimeout(minuterie);
    minuterie = setTimeout(controler, 300);
  };
  let dernierAjout = '';

  window.fetch = async function (entree, init) {
    const nom = route(entree);
    if (!nom) return fetchOrigine(entree, init);
    const c = init && init.body ? lireCorps(init.body) : null;
    if (c) {
      try {
        const borne = await borner(nom, c);
        if (borne.refus) return refus(borne.refus);
        init = { ...init, body: ecrireCorps(borne) };
      } catch (e) {}
    }
    const r = await fetchOrigine(entree, init);
    if (nom === 'add')
      r.clone()
        .json()
        .then((d) => (dernierAjout = d.handle || (d.items && d.items[0] && d.items[0].handle) || ''))
        .then(surveiller)
        .catch(() => {});
    planifierControle();
    return r;
  };

  // Lignes au-delà du maximum (ajout hors thème, /cart/add direct, autre onglet) : ramenées au maximum.
  async function controler() {
    let corrige = false;
    try {
      const panier = await lirePanier();
      const qte = parVariante(panier);
      for (const [variante, total] of Object.entries(qte)) {
        const lignes = panier.items.filter((l) => String(l.variant_id) === variante).reverse();
        let exces = total - (await limiteHandle(lignes[0].handle));
        for (const l of lignes) {
          if (exces <= 0) break;
          const retire = Math.min(exces, l.quantity);
          await fetchOrigine('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: l.key, quantity: l.quantity - retire }),
          });
          exces -= retire;
          corrige = true;
        }
      }
    } catch (e) {}
    if (!corrige) return;
    let dernier = 0;
    try {
      dernier = parseInt(sessionStorage.getItem('limiteQteRecharge') || '0', 10);
      sessionStorage.setItem('limiteQteRecharge', String(Date.now()));
    } catch (e) {}
    if (Date.now() - dernier > 10000) location.reload();
  }

  // Sélecteurs de quantité : max, valeur bornée, « + » bloqué, message.
  const handleDuSelecteur = (input) => {
    const ligne = input.closest('.cart-item');
    if (ligne) return handleDeLien(ligne.querySelector('a[href*="/products/"]'));
    const info = input.closest('product-info');
    if (info && info.dataset.url) return info.dataset.url.match(/\/products\/([^/?#]+)/)?.[1] || '';
    return location.pathname.match(/\/products\/([^/?#]+)/)?.[1] || '';
  };
  const appliquer = () => {
    document.querySelectorAll('input.quantity__input').forEach((input) => {
      const max = limiteConnue(handleDuSelecteur(input));
      if (max === Infinity) return;
      if (input.dataset.cartQuantity !== undefined && !input.closest('.cart-item')) {
        // Fiche produit : Dawn calcule max = data-max − quantité déjà au panier.
        const plafond = Math.min(parseInt(input.dataset.max, 10) || Infinity, max);
        if (input.dataset.max !== String(plafond)) input.dataset.max = plafond;
        const voulu = Math.max(0, plafond - (parseInt(input.dataset.cartQuantity, 10) || 0));
        if (input.max !== String(voulu)) input.max = voulu;
      } else {
        const voulu = Math.min(parseInt(input.max, 10) || Infinity, max);
        if (input.max !== String(voulu)) input.max = voulu;
      }
      if (parseInt(input.value, 10) > parseInt(input.max, 10)) input.value = input.max;
      if (!input.dataset.limiteQte) {
        input.dataset.limiteQte = '1';
        input.addEventListener('input', () => {
          if (parseInt(input.value, 10) > parseInt(input.max, 10)) input.value = input.max;
        });
      }
      const bloc = input.closest('quantity-input') || input;
      const cellule = input.closest('.cart-item__quantity');
      if (cellule) {
        if (!cellule.querySelector('.limite-qte')) cellule.insertAdjacentHTML('beforeend', `<p class="limite-qte">${message(max)}</p>`);
      } else if (!bloc.parentElement.querySelector(':scope > .limite-qte'))
        bloc.insertAdjacentHTML('afterend', `<p class="limite-qte">${message(max)}</p>`);
      if (typeof bloc.validateQtyRules === 'function') bloc.validateQtyRules();
    });
    const notif = document.getElementById('cart-notification-product');
    const maxNotif = dernierAjout ? limiteConnue(dernierAjout) : Infinity;
    if (notif && notif.children.length && maxNotif !== Infinity && !notif.querySelector('.limite-qte'))
      notif.insertAdjacentHTML('beforeend', `<p class="limite-qte">${message(maxNotif)}</p>`);
  };

  let image;
  function surveiller() {
    cancelAnimationFrame(image);
    image = requestAnimationFrame(appliquer);
  }
  const demarrer = () => {
    appliquer();
    new MutationObserver(surveiller).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['max', 'data-max', 'data-cart-quantity'],
    });
    controler();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
